<script>
export default {
  name: "render-vnode",
  props: {
    vNode: null
  },
  setup(props) {
    return () => props.vNode;
  }
}
</script>
